module.exports = __webpack_public_path__ + "img/single.93b76c84.png";